/**
 * Determines if the user is able to contribute to the given entity
 *
 * @param {Object} entity The entity we are checking for contributor access
 * @param {Object} isAllowed if the user is allowed to upload photos to this entity
 * @param {Object} isAllowedToUploadVideo if the user is allowed to upload videos to this entity
 * @returns {boolean} Whether the user is able to contribute or not
 */
import { isAlbum, isVideoAlbum } from '../../../util/album';
import { PERMISSION_NONE } from '../../../constants/contributors';

export const canContributeToEntity = (
  entity,
  isAllowed,
  isAllowedToUploadVideo,
) => {
  const autoContributorShareUrl = entity?.auto_contributor_share_url;

  // Scenarios where we dont allow contribution
  // - The user is not allowed to upload and the entity doesnt have upload access
  // - The user is not allowed to upload and the entity doesnt have shareUrl
  // - The user is not allowed to upload and the entity is not found
  if (!entity) {
    return false;
  }

  if (
    isAlbum(entity) &&
    isVideoAlbum(entity) &&
    !isAllowedToUploadVideo &&
    (entity.auto_contributor_settings?.upload_access === PERMISSION_NONE ||
      !autoContributorShareUrl)
  ) {
    return false;
  }

  if (
    !isVideoAlbum(entity) &&
    !isAllowed &&
    (!entity ||
      entity.auto_contributor_settings?.upload_access === PERMISSION_NONE ||
      !autoContributorShareUrl)
  ) {
    return false;
  }

  return true;
};
